// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"N3f","link":"N3ch","imgWrap":"N3abj","statistic":"N3a5","primary":"N3bl","header":"N3ap","secondary":"N3arx","light":"N3cz","dark":"N3aj9"};